module.exports = __webpack_public_path__ + "img/green.bd7ab6b5.jpg";